document.addEventListener('DOMContentLoaded', function () {
	const targetNode = document.body; // Assuming changes occur in the body
	const config = { childList: true, subtree: true };

	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			// Check for added nodes specifically
			if (mutation.addedNodes && mutation.addedNodes.length > 0) {
				mutation.addedNodes.forEach((node) => {
					// Ensure the node is an element node (not text or comment)
					if (node.nodeType === 1) {
						// Check if new pagination buttons are added
						if (
							node.matches('.pr-rd-pagination-btn') ||
							node.querySelector('.pr-rd-pagination-btn')
						) {
							// Apply 'nofollow' to this button or any within it
							applyNoFollow(node);
						}
					}
				});
			}
		});
	});

	// Helper function to add 'nofollow' to pagination buttons
	function applyNoFollow(element) {
		// If the element itself is a pagination button, set nofollow
		if (element.matches('.pr-rd-pagination-btn')) {
			element.setAttribute('rel', 'nofollow');
		}
		// Otherwise, look for any pagination buttons within the element
		const paginationButtons = element.querySelectorAll(
			'.pr-rd-pagination-btn'
		);
		paginationButtons.forEach((button) => {
			button.setAttribute('rel', 'nofollow');
		});
	}

	// Start observing the document
	observer.observe(targetNode, config);
});
